import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { batch_details_loading : true, batch_details: '', batch_details_error: false};

export function batchDetail(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_BATCH_DETAILS:
        return {
            batch_details_loading: true,
            batch_details: '',
            batch_details_error: false
        };
      case organisationConstants.RECIEVE_BATCH_DETAILS:
        return {
            batch_details_loading: false,
            batch_details: action.batch_details,
            batch_details_error: false
        };
      case organisationConstants.ERROR_BATCH_DETAILS:
        return { 
            batch_details_loading: false,
            batch_details: '',
            batch_details_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/batchDetails.reducer.js